module.exports = __webpack_public_path__ + "img/Comic01-1.54c199ae.png";